import React from 'react';
import { BootstrapStyles } from '../styles/spBootstrapExtended';
import { PageHeadStyles } from '../shared/components/PageHead';
import { SiteGlobalStyles } from '../styles';

export default function LayoutMain(props: {
  alert?: React.ReactNode;
  navigation: React.ReactNode;
  content?: React.ReactNode;
  footer: React.ReactNode;
}) {
  return (
    <React.Fragment>
      <BootstrapStyles />
      <SiteGlobalStyles />
      <PageHeadStyles />

      <div data-testid="root-layout">
        {props.alert}
        {props.navigation}

        <div className="main">
          <div id="content">{props.content}</div>
        </div>

        {props.footer}
      </div>
    </React.Fragment>
  );
}
